<template>
    <div v-if="$store.state.dev && $store.state.lbls" class="font-weight-light subtitle-2 red--text">
            <slot />
    </div>
</template>

<script>
  export default {
    name: "Lbls",
  }
</script>